<a [routerLink]="href" class="rek-icon-card kt-portlet kt-iconbox">
  <div class="kt-portlet__body">
    <div class="kt-iconbox__body">
      <div class="kt-iconbox__icon">
        <ng-content></ng-content>
      </div>
      <div class="kt-iconbox__desc">
        <h3 class="kt-iconbox__title">{{ cardTitleTranslateKey | translate }}</h3>
        <div class="kt-iconbox__content">{{ cardSubtitleTranslateKey | translate }}</div>
      </div>
    </div>
  </div>
</a>